export function historyBackTo({ key, router, fallback }) {
  const url = sessionStorage.getItem(key);
  if (url) {
    location.href = url;
  } else {
    router.push(fallback);
  }
}
